<label 
    class="base-input-container {{inputBorderClasses[borderStyle]}} {{size}}"
    [for]="formControlName" 
    [ngClass]="{'focused': inputFocused, 'disabled': disabled, 'readonly': readonly, 'processing': processing, 'error': error}">
    <input 
        class="input {{inputClass}}" 
        [attr.name]="formControlName" 
        type="text"
        [attr.placeholder]="placeholder" 
        [value]="value" 
        [(ngModel)]="value" 
        class="input"
        (focus)="onInputFocus()" 
        (focusout)="onInputFocusOut()" 
        [attr.disabled]="disabled || processing ? '' : null"
        [attr.readonly]="readonly ? '' : null" 
        [attr.invalid]="error ? '' : null" 
        [attr.maxlength]="maxLength" 
        min="1"
        autocomplete="off"
        [attr.max]="max"
        #input>
    <!-- Suffix icon -->
    <div *ngIf="!!iconClass && !disabled" 
        class="input-suffix input-icon {{iconClass}}" 
        (click)="toggleIcon()" 
        [display]="!!tooltipContent"
        [appSmashTooltip]="informationsTooltipTemplate" 
        contentType="template"
        [placement]="defaultTooltipDirection" 
        [autoPlacement]="true" 
        hide-delay="100" 
        theme="light">
    </div>
</label>

<ng-content select="[error]"></ng-content>

<ng-template #informationsTooltipTemplate>
    <div class="tooltip-content">
        {{tooltipContent}}
    </div>
</ng-template>